import React from "react";
import { WINE_BOTTLES, MIXED_CASE_SIZE } from "../../mock";

const FILL = { "Chenin Blanc": "#e3cf8a", "Shiraz": "#5a1e2c", "Rosé": "#e8a0a6", "Reserve Chenin Blanc": "#d4b35a", "Reserve Red": "#4a1420", "Heritage Chenin Blanc": "#c99a3a", "Heritage Syrah": "#3a0f1b" };

const Bottle = ({ fill, label, index, dark }) => (
  <svg viewBox="0 0 24 64" width="26" height="70" className={`transition-all duration-500 ${fill ? "opacity-100 translate-y-0" : "opacity-40"}`} style={{ transitionDelay: `${index * 40}ms` }} aria-label={label || "empty slot"} data-testid={`bottle-slot-${index}`}>
    <title>{label || "Empty slot"}</title>
    <path d="M9 2h6v10c0 2 5 5 5 12v34a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V24c0-7 5-10 5-12V2z" fill={fill || "transparent"} stroke={fill ? "#f6f1e7" : dark ? "#f6f1e7" : "#1f4a33"} strokeOpacity={fill ? 0.55 : 1} strokeWidth="1.2" strokeDasharray={fill ? "0" : "3 2"} style={{ transition: "fill 0.4s ease" }} />
    {fill && <rect x="9" y="2" width="6" height="4" fill="#2a2320" />}
    {fill && <rect x="6" y="34" width="12" height="16" rx="1" fill="#f6f1e7" opacity="0.9" />}
    {fill && <path d="M7 22c-1 2-1 4-1 6" stroke="#ffffff" strokeOpacity="0.35" strokeWidth="1.5" strokeLinecap="round" />}
  </svg>
);

export default function MixedCasePreview({ mix }) {
  const bottles = WINE_BOTTLES.flatMap((b) => Array.from({ length: mix[b.name] || 0 }, () => b.name)).slice(0, MIXED_CASE_SIZE);
  const slots = [...bottles, ...Array(Math.max(0, MIXED_CASE_SIZE - bottles.length)).fill(null)];
  return (
    <div className="mt-5 rounded-2xl bg-[#10271a] px-5 pt-4 pb-3 relative overflow-hidden" data-testid="mixed-case-preview">
      <p className="text-[10px] tracking-[0.2em] uppercase text-[#b08a5f]">Your case</p>
      <div className="mt-2 flex items-end justify-center gap-2.5 relative z-10">
        {slots.map((name, i) => <Bottle key={i} index={i} fill={name ? FILL[name] : null} label={name} dark />)}
      </div>
      <div className="mt-[-6px] mx-auto h-5 w-[230px] rounded-sm bg-[#8a6a3c] shadow-[inset_0_3px_0_rgba(0,0,0,0.25)] relative z-0" />
      <div className="mt-2 flex flex-wrap justify-center gap-x-3 gap-y-1 text-[10px] text-[#f6f1e7]/70">
        {WINE_BOTTLES.filter((b) => mix[b.name] > 0).map((b) => (
          <span key={b.name} className="inline-flex items-center gap-1.5"><span className="h-2 w-2 rounded-full" style={{ background: FILL[b.name] }} />{mix[b.name]}× {b.name}</span>
        ))}
        {bottles.length === 0 && <span className="text-[#f6f1e7]/40">Add bottles below to fill your case</span>}
      </div>
    </div>
  );
}
